// extracted by mini-css-extract-plugin
module.exports = {"image":"slide_image__iSFNk","wrapper":"slide_wrapper__cD5qP"};